import { render } from "./admissionSection.vue?vue&type=template&id=6ad35d94&scoped=true"
import script from "./admissionSection.vue?vue&type=script&lang=js"
export * from "./admissionSection.vue?vue&type=script&lang=js"

import "./admissionSection.vue?vue&type=style&index=0&id=6ad35d94&scoped=true&lang=css"

import exportComponent from "/Users/content/Documents/Biggie/triple_palm/photography-landing-page-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad35d94"]])

export default __exports__